import { type ICategoriesApi } from 'infrastructure/apis/categories/ICategoriesApi';
import { type ICategoriesService } from './ICategoriesService';
import { Category } from 'domains/category';
import { CategoryMapper } from 'infrastructure/mappers/category';
import { CategoryRequestDTO } from 'infrastructure/dtos/category';

export class CategoriesService implements ICategoriesService {
  constructor(private readonly categoriesApi: ICategoriesApi) {}

  async getCategories(): Promise<Category[]> {
    const response = await this.categoriesApi.getCategories();

    const categories = response.data.map(CategoryMapper.fromDTO);

    return categories;
  }

  async createCategory(dto: CategoryRequestDTO): Promise<Category> {
    const response = await this.categoriesApi.createCategory(dto);

    return CategoryMapper.fromDTO(response.data);
  }
}
